import ItemActions from './ItemActions'

module.exports = ItemActions.create( { 
  parentName : 'project', 
  itemsName : 'messageRoutes', 
  // itemRootName : 'messageRoute',
  actionTypeBase : 'MESSAGE_ROUTE', 
  parentIdKey : 'projectId', 
  humanItemName : 'Message Route' 
} )
